import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";

import TtIntakeSettingFormModal from "@/components/modules/account/TtIntakeSettingFormModal.vue";
import { useTranslation } from "@/store/translation";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TtProfile',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as { user: User };


const showIntakeSettingModal = ref(false);

const { $t } = useTranslation();


const showUplinePl = computed(() => {

  return props.user.intakeType === "layer";
})


function formatBoolean(bool: boolean) {
  return bool ? "Yes" : "No";
}


return { __sfc: true,props, showIntakeSettingModal, $t, showUplinePl, formatBoolean, TtIntakeSettingFormModal }
}

})